import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  bomasTestLessonData: [],
  bomasTestLessonCount: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
}

export const bomasTestLessonSlice = createSlice({
  name: "bomasTestbomasTestLesson",
  initialState,
  reducers: {
    setbomasTestLessonData(state, { payload }) {
      state.bomasTestLessonData = payload.result;
      state.bomasTestLessonCount = payload.total
    },
    updatebomasTestLessonData(state, { payload }) {
      const objIndex = state.bomasTestLessonData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.bomasTestLessonData[objIndex] = payload
      }
    },
    deletebomasTestLessonData(state, { payload }) {
      const objIndex = state.bomasTestLessonData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.bomasTestLessonData.splice(objIndex, 1)
        state.bomasTestLessonCount -=1
      }
    },
    pushbomasTestLessonData(state, { payload }) {
      state.bomasTestLessonData.push(payload)
      state.bomasTestLessonCount +=1;
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setbomasTestLessonData, updatebomasTestLessonData, deletebomasTestLessonData, pushbomasTestLessonData, isOpenModal,
  ModalToggle, setFaqsSpecializationData, isOpenStatusModal, statusToggle } = bomasTestLessonSlice.actions;

export default bomasTestLessonSlice.reducer;

export function getbomasTestLesson(limit, offset, status, keyword, id) {
  return async function getbomasTestLessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getbomasTestLesson(limit, offset, status, keyword, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setbomasTestLessonData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addbomasTestLesson(payload) {
  return async function addbomasTestLessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addbomasTestLesson(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushbomasTestLessonData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatebomasTestLesson(id, data) {
  return async function updatebomasTestLessonThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatebomasTestLesson(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatebomasTestLessonData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdatebomasTestLesson(payload) {
  return async function statusUpdatebomasTestLessonThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatebomasTestLesson(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updatebomasTestLessonData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeletebomasTestLesson(payload) {
  return async function statuseletebomasTestLessonThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatebomasTestLesson(payload.id, payload.status).then(
        (response) => {
          dispatch(deletebomasTestLessonData(payload.id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

